import { render } from "./TrabajoRealizadoNuevoProveedor.vue?vue&type=template&id=5b4e06c0"
import script from "./TrabajoRealizadoNuevoProveedor.vue?vue&type=script&lang=js"
export * from "./TrabajoRealizadoNuevoProveedor.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__